// extracted by mini-css-extract-plugin
module.exports = {"root":"OptionsList_root__djTVV"};